"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Child = void 0;
var child_age_gender_mapper_constants_1 = require("../child-age-gender-mapper.constants");
/**
 * Core mapper class for new child age gender qualification.
 * A instance of this class represent one child, its age, gender and
 * the new condition code that represents it.
 * This class use new child age gender condition code to determine child age and gender.
 */
var Child = /** @class */ (function () {
    /**
     * Create a new Child from a new child gender age condition code.
     */
    function Child(code) {
        if (code < child_age_gender_mapper_constants_1.START_BABY_AGE_CODE || code > child_age_gender_mapper_constants_1.NO_CHILDREN_CODE) {
            throw new Error('Child, gender and age criterias code is out of the range of mapped codes');
        }
        this.code = code;
    }
    /**
     * Create a new Child from criterias
     * @param {boolean} isBaby - true for baby ages, meaning months from 1 to 11.
     * false for child ages, meaning years from 1 to 17.
     * @param {boolean} isBoy - child gender: true for boy or false for girl.
     * @param {number} age - child age.
     * @returns a new Child instance
     */
    Child.create = function (isBaby, isBoy, age) {
        if (age <= 0) {
            throw new Error("Invalid age informed: ".concat(age));
        }
        if (isBaby && age > child_age_gender_mapper_constants_1.MONTHS) {
            throw new Error("Invalid baby age informed: ".concat(age));
        }
        if (!isBaby && age > child_age_gender_mapper_constants_1.YEARS) {
            throw new Error("Invalid child age informed: ".concat(age));
        }
        var addValue = (isBaby ? child_age_gender_mapper_constants_1.START_BABY_AGE_CODE : child_age_gender_mapper_constants_1.START_CHILD_AGE_CODE) - 1;
        var subtractValue = isBoy ? 1 : 0;
        var code = age * 2 + addValue - subtractValue;
        return new Child(code);
    };
    Child.createNoChildren = function () {
        return new Child(child_age_gender_mapper_constants_1.NO_CHILDREN_CODE);
    };
    Object.defineProperty(Child.prototype, "noChildren", {
        get: function () {
            return this.code === child_age_gender_mapper_constants_1.NO_CHILDREN_CODE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Child.prototype, "isBaby", {
        get: function () {
            return this.code <= child_age_gender_mapper_constants_1.END_BABY_AGE_CODE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Child.prototype, "isBoy", {
        get: function () {
            return this.code % 2 !== 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Child.prototype, "age", {
        get: function () {
            var subtractValue = (this.isBaby ? child_age_gender_mapper_constants_1.START_BABY_AGE_CODE : child_age_gender_mapper_constants_1.START_CHILD_AGE_CODE) - 1;
            return Math.ceil((this.code - subtractValue) / 2);
        },
        enumerable: false,
        configurable: true
    });
    return Child;
}());
exports.Child = Child;
